import { PageContainer, ProCard } from '@ant-design/pro-components'
import { createFileRoute, Link } from '@tanstack/react-router'
import { Button, Result } from 'antd'

export const Route = createFileRoute('/_authenticated/unauthorized')({
  component: UnauthorizedPage,
  head: () => ({ meta: [{ title: '权限不足 · Super Mega' }] })
})

function UnauthorizedPage() {
  return (
    <PageContainer breadcrumbRender={false}>
      <ProCard>
        <Result
          extra={
            <Link to="/home">
              <Button type="primary">返回工作台</Button>
            </Link>
          }
          status="403"
          subTitle="当前账号没有访问此页面所需的权限。若职责已调整，请联系顶级账户更新角色。"
          title="权限不足"
        />
      </ProCard>
    </PageContainer>
  )
}
